/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { BOOKING_DATE } from 'modules/dashboard/constants';
/**
 * Common date change patterns are defined here
 */
export const DATE_PATTERN = 'MM-dd-yyyy';
//
export const YEAR_MONTH_DAY_PATTERN = 'yyyy-MM-dd';
//
export const YEAR_MONTH_PATTERN = 'yyyy-MM';
//
export const DATE_TIME_PATTERN = 'yyyy-MM-dd HH:mm:ss';
//
export const FILE_NAME_TIMESTAMP_PATTERN = "yyyy-MM-dd'T'HH-mm-ss-SSS";
//
export const TIME_PATTERN = 'hh:mm:ss a';
//
export const ISO_YEAR_MONTH_DAY_PATTERN = 'yyyyMMdd';
//
export const EXCEL_YEAR_MONTH_DAY_PATTERN = 'yyyy/MM/dd';
//
export const MONTH_NAME_DAY_YEAR_PATTERN = 'MMM dd, yyyy';
//
export const DATE_TIME_WITH_AM_PM_PATTERN = 'yyyy-MM-dd hh:mm:ss a';
//
export const YEAR_MONTH_DAY_HOUR_MINUTE_TZ_PATTERN = 'yyyy-MM-dd HH:mm ZZZZ';

/**
 * Default stay date min date is defined here
 */
export const STAY_DATE_START_DATE = '2015/01/01';
/**
 * Default stay date max date is defined here
 */
export const STAY_DATE_END_DATE = '2030/12/31';
/**
 * Default booking date min date is defined here
 */
export const BOOKING_DATE_START_DATE = BOOKING_DATE;
/**
 * Default infinite max date is defined here
 */
export const INFINITE_DATE = {
  date: '9999-09-09',
  label: 'Current',
};
